// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__tto1y"};